import { observer } from 'mobx-react-lite';

import { Button } from '@components/button';
import { IconAddPlus } from '@components/icons/add-plus';

import { useModal } from 'features/modals';
import { usePermissions } from 'features/permissions';
import { useStore } from 'models/Provider';

export const CreateUserButton = observer(({ fullWidth = false }) => {
  const { t } = useStore();
  const { hasRolePermission } = usePermissions();
  const { showModal } = useModal();
  if (!hasRolePermission('team:create-user')) return null;

  return (
    <Button
      data-cy="add-user"
      {...(fullWidth && { style: { width: '100%' } })}
      iconLeft={<IconAddPlus />}
      onClick={() => {
        showModal('CREATE_USER', {
          _container: {
            width: '460px',
            closeOnOverlayClickOrEsc: false,
          },
        });
      }}
      text={t('user.button.create')}
    />
  );
});
